import { PayloadAction } from "@reduxjs/toolkit"
import { IInitialState } from "./types"



export const reducers = {

    setClientId: (state: IInitialState, action: PayloadAction<number | null>) => {
        state.clientId = action.payload
    },
    setProfileStatus: (state: IInitialState, action: PayloadAction<"worker" | "salon" | "individual" | null>) => {
        state.profileStatus = action.payload
    },
    setDateBirthDay: (state: IInitialState, action: PayloadAction<string | null>) => {
        state.dateBirthDay = action.payload
    },
    setServicesImages: (state: IInitialState, action: PayloadAction<string>) => {
        state.servicesImages = [...state.servicesImages, action.payload]
    },
    setDeleteServicesImages: (state: IInitialState, action: PayloadAction<string>) => {
        state.servicesImages = state.servicesImages.filter(item => item !== action.payload)
    },
    setDeleteServicesImagesById: (state: IInitialState, action: PayloadAction<number>) => {
        state.servicesImages = state.servicesImages.filter(item => item.id !== action.payload)
    },
    setCleanServicesImages: (state: IInitialState) => {
        state.servicesImages = []
    },
    setBrandsImages: (state: IInitialState, action: PayloadAction<any>) => {
        state.brandsImages = [...state.brandsImages, action.payload]
    },
    setDeleteBrandsImages: (state: IInitialState, action: PayloadAction<number>) => {
        state.brandsImages = state.brandsImages.filter(item => item.id !== action.payload)
    },
    setCleanBrandsImages: (state: IInitialState) => {
        state.brandsImages = []
    },
    setOldImagesId: (state: IInitialState, action: PayloadAction<number>) => {
        state.oldImagesId = [...state.oldImagesId, action.payload]
    },
    setCleanOldImagesId: (state: IInitialState) => {
        state.oldImagesId = []
    },
    setServiceAdvancedSettingsClean: (state: IInitialState) => {
        state.serviceAdvancedSettings = {}
    },
    setCleanClientView: (state: IInitialState) => {
        state.clientView = {
            id: 0,
            image_url: '',
            name: '',
            instagram_username: '',
            instagram_image: '',
            phone_number: '',
            email: '',
            birthday: '',
            country: '',
            family_status: '',
            hobbies: '',
            about_service_notes: '',
            other_notes: '',
            label: {
                id: -1,
                color: "",
                name: ""
            }
        }
    },
    setUpdateInstagramView: (state: IInitialState) => {
        state.instagramView = {
            instagram_username: "",
            image_url: ""
        }
    },
    setUpdateSocialProfileView: (state: IInitialState, action: PayloadAction<string>) => {

        if (action.payload === "Instagram") {
            state.socialProfile.instagram = null;
        } else if (action.payload === "Whatsapp") {
            state.socialProfile.whatsapp = null;
        }
    },
    setUpdateCheckAddress: (state: IInitialState) => {
        state.checkAddress.has_address_url = true
    },
    setHistory: (state: IInitialState, action: PayloadAction<any>) => {
        state.history = action.payload
    }
}